import { paramCase } from 'change-case'
import { AssetReference } from '@opallabs/cassini'
import { kuiperClassNames } from '@opallabs/kuiper'
import type { Asset, OnShowAssetPickerProps } from '../../helpers/types'
import { Single, Feed } from './displays'
import * as styles from './styles'

interface RedditPromotedPostProps {
  accountImage: Asset | null
  accountUsername: string
  assets?: Asset[]
  content?: string
  display: string
  redditCta?: string
  redditDestinationUrl?: string
  isPresenting: boolean
  onExpandAsset?: (assetId: number) => void
  onRemoveAsset?: (assetId: number) => void
  onShowAssetPicker?: (args: OnShowAssetPickerProps) => void
  postType: string
  readOnly: boolean
  updateAssets?: (assets: AssetReference[]) => void
  updateCaption?: () => void
  updateText?: (val: string, destination: string) => void
}

const displays = {
  mobileSingle: Single,
  desktopFeed: Feed,
  default: Single,
}

function isValidDisplay(display: string): display is keyof typeof displays {
  return Object.keys(displays).includes(display)
}

export const RedditPromotedPost: React.FC<RedditPromotedPostProps> = ({
  accountImage,
  accountUsername,
  assets,
  content,
  display,
  redditCta,
  redditDestinationUrl,
  isPresenting,
  onExpandAsset,
  onRemoveAsset,
  updateCaption,
  updateText,
  readOnly,
}) => {
  const RenderDisplay = isValidDisplay(display)
    ? displays[display]
    : displays.default

  return (
    <div
      css={styles.baseStyles}
      style={
        {
          '--display-width': `${styles.renderDisplayLayout[isValidDisplay(display) ? display : 'default']}px`,
        } as React.CSSProperties
      }
      className={kuiperClassNames(
        'reddit reddit-promoted-post',
        `reddit-${paramCase(display)}`
      )}
    >
      <RenderDisplay
        accountImage={accountImage}
        accountUsername={accountUsername}
        assets={assets || []}
        headline={content || ''}
        cta={redditCta || 'No Button'}
        destinationUrl={redditDestinationUrl || ''}
        isPresenting={isPresenting}
        onHeadlineChange={
          updateText ? (val: string) => updateText(val, 'content') : undefined
        }
        onExpandAsset={onExpandAsset}
        onRemoveAsset={onRemoveAsset}
        readOnly={readOnly}
        updateCaption={updateCaption}
      />
    </div>
  )
}
